





















import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import RemoteLinkMainTable from "./RemoteLinkMainTable.vue";
import RemoteLinkSummary from "./RemoteLinkSummary.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchInstallationsRemoteLinkStatusCommand, FetchInstallationsRemoteLinkStatusReqData } from "@/model/communication/remoteLink/FetchInstallationsRemoteLinkStatusCommand";
import { FetchInstallationsRemoteLinkStatusResData } from "@/model/communication/remoteLink/FetchInstallationsRemoteLinkStatusResData";

export default Vue.extend({
    components: {
        StandardPage,
        RemoteLinkMainTable,
        RemoteLinkSummary,
    },
    data() {
        return {
            RemoteLinkMainTable,
            routes,
            dataTableItemsPerPage,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
            loadingSummary: false,
            totalActiveSession: 0,
            totalInactiveSession: 0,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                this.loadingSummary = true;
                let response: FetchInstallationsRemoteLinkStatusResData = await new FetchInstallationsRemoteLinkStatusCommand(request).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                    this.totalInactiveSession = response.totalInactiveSession;
                    this.totalActiveSession = response.totalActiveSession;
                }
            } catch (e) {
                console.log("Something went wrong sending GetInstallationsEnabledModules request ", e);
            }
            this.loading = false;
            this.loadingSummary = false;
        },
        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
    mounted() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            this.reqData = JSON.parse(atob(this.$route.query.reqData));
        } else {
            this.reqData = new FetchInstallationsRemoteLinkStatusReqData();
            this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        }
    },
});
